import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import dentalImage from 'images/content/Dental-Insurance.jpg'

const FifthSection = () => {
    return (
        <>
            <div className="space-y-4 flex flex-col justify-center lg:justify-between items-center lg:flex-row gap-x-12 ">
                <img src={dentalImage} alt="dental" />

                <div className="space-y-4">

                    <div className='text-4xl font-bold'>How Our Group Insurance Works</div>
                    <p>When comparing features of group health insurance, you may be able to get more coverage options for less money. Our insurance benefits work in the following way:</p>
                    <ul>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> How often do I visit the doctor?</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> What type of treatment do I need in the next 12 months?</li>
                    </ul>
                    <p>How much does health insurance cost your business? On average, you can get a comprehensive plan for $250 to $300 per employee. A group health insurance plan for five people typically costs $1400 to $1500 per month.</p>
                </div>
            </div>
        </>
    );
}

export default FifthSection;
